import type { SupervisorFindingWithRow } from '@avisoma/shared';
import type { RowFindings } from './FindingMarkerCell';

/**
 * Supervisor findings keyed family → row index (the row's position in that family's
 * `consolidatedExtraction` array), so a table looks its rows up instead of filtering the
 * whole list per row. Findings with no family or no resolvable row stay off the tables.
 */
export function findingsByFamily(findings: SupervisorFindingWithRow[]): Map<string, RowFindings> {
  const out = new Map<string, RowFindings>();
  for (const f of findings) {
    if (!f.family || f.rowIndex === null) continue;
    const byRow: RowFindings = out.get(f.family) ?? new Map();
    byRow.set(f.rowIndex, [...(byRow.get(f.rowIndex) ?? []), f]);
    out.set(f.family, byRow);
  }
  return out;
}
